import {Box, CircularProgress, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React from "react";
import {signingControls} from "./signingColors";

interface Props {
    title?: string;
    description?: string;
    busyLabel?: string;
    visual?: React.ReactNode;
    action?: React.ReactNode;
}

function SigningNotice({title, description, busyLabel, visual, action}: Props) {
    const controls = signingControls(useTheme());

    return (
        <Stack alignItems={'center'} sx={{textAlign: 'center', py: {xs: 6, sm: 9}}}>
            {visual}
            {!!busyLabel && (
                <CircularProgress size={28} thickness={3} aria-label={busyLabel} sx={{color: controls.accent}}/>
            )}
            {!!title && (
                <Typography variant={'h2'} component={'h1'} sx={{maxWidth: 460, mt: visual ? 1.5 : 0, textWrap: 'balance', whiteSpace: 'pre-line'}}>
                    {title}
                </Typography>
            )}
            {!!description && (
                <Typography variant={'body1'} color={'text.secondary'} sx={{maxWidth: 420, mt: 1.5, textWrap: 'pretty'}}>
                    {description}
                </Typography>
            )}
            {!!action && <Box sx={{mt: 4, width: '100%', maxWidth: 320}}>{action}</Box>}
        </Stack>
    );
}

export default SigningNotice;
